import useBodyStyleWhileMounted from './useBodyStyleWhileMounted';

/**
 * This hook can be used to disable horizontal overscroll behavior on the document. Practically, this disables
 * swiping left/right with two fingers on a trackpad to go forward/back in a browser. This can be useful in
 * situations where you want the user to be able to navigate an infinite diagram or canvas by panning
 * with two fingers.
 *
 * @param enabled Disable horizontal overscroll if true, don't otherwise. See useBodyStyleWhileMounted
 * documentation for more.
 */
export default function useDisabledHorizontalOverscroll(enabled: boolean = true): void {
  useBodyStyleWhileMounted('overscrollBehaviorX', 'none', enabled);
}
